import { render, staticRenderFns } from "./UserPersonalData.vue?vue&type=template&id=0eed78a6&"
import script from "./UserPersonalData.vue?vue&type=script&lang=js&"
export * from "./UserPersonalData.vue?vue&type=script&lang=js&"
import style0 from "./UserPersonalData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports